"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeoLedgerAccount = void 0;
const address_1 = require("../../../util/address");
const ledger_1 = require("../../../util/ledger");
const neon_core_next_1 = require("@cityofzion/neon-core-next");
const NeonN3Ledger = __importStar(require("./N3Ledger"));
const NeonLedger_1 = __importStar(require("./NeonLedger"));
const CONNECT_POLL_INTERVAL = 3000; // ms
const CONNECT_POLL_ATTEMPTS = 10; // attempts
const addressUtilForVersion = (version) => {
    if (version === "n3")
        return address_1.N3Address;
    return address_1.NEOAddress;
};
const adapterForVersion = (version) => {
    if (version === "n3")
        return NeonN3Ledger;
    return NeonLedger_1.default;
};
class NeoLedgerAccount {
    constructor(ledger, publicKey, version = "neo") {
        this.options = {};
        this.ledger = ledger;
        this.publicKey = publicKey;
        this.version = version;
        const neoAddressUtil = addressUtilForVersion(version);
        this.scriptHash = neoAddressUtil.publicKeyToScriptHash(publicKey);
        this.displayAddress = neoAddressUtil.publicKeyToAddress(publicKey);
    }
    static connect(version = "neo") {
        return __awaiter(this, void 0, void 0, function* () {
            let connectResult = null;
            let connectionAttempts = 0;
            NeoLedgerAccount._connectPolling = true;
            while (connectionAttempts < CONNECT_POLL_ATTEMPTS) {
                connectionAttempts++;
                // external signal to stop polling (e.g. timeout)
                // exit loop
                if (!NeoLedgerAccount._connectPolling) {
                    break;
                }
                // attempt ccnnect
                connectResult = yield new Promise((resolve, reject) => {
                    let timedOut = false;
                    // start timeout to kill connection when interval duration
                    // is reached. Kills connection by resolving
                    let timeoutId = setTimeout(() => {
                        // set timeout to true so that if connection is successful
                        // after timeout, it can be ignored.
                        timedOut = true;
                        // returns null result to indicate connection failure
                        resolve(null);
                    }, CONNECT_POLL_INTERVAL);
                    NeoLedgerAccount.tryConnect()
                        .then((result) => {
                        // check for timeout signal, abandon result if timed out
                        if (timedOut)
                            return;
                        // clear timeout timer, so it doesn't trigger timeout action
                        clearTimeout(timeoutId);
                        // return positive connection result
                        resolve(result);
                    })
                        .catch(reject);
                });
                // connection successful, exit loop
                if (connectResult) {
                    break;
                }
            }
            // failed to connect after specified timeout
            if (!connectResult) {
                throw new Error("Failed to connect with USB device, please try again.");
            }
            const [ledger, publicKey] = connectResult;
            return new NeoLedgerAccount(ledger, publicKey, version);
        });
    }
    /**
     * Used to try connecting with ledger, executes a public key request
     * on USB device to detect NEO app connection
     */
    static tryConnect(version = "neo") {
        return __awaiter(this, void 0, void 0, function* () {
            const bipString = NeonLedger_1.getNEOBIP44String();
            const ledger = yield ledger_1.getLedgerTransport();
            // get public key to assert that NEO app is open
            const ledgerAdapter = adapterForVersion(version);
            const publicKey = yield ledgerAdapter.getPublicKey(ledger, bipString);
            return [ledger, publicKey];
        });
    }
    configureAddress(options) {
        this.options = options;
    }
    privateKey() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Cannot retrieve private key from Ledger");
        });
    }
    sign(msg, magic = neon_core_next_1.CONST.MAGIC_NUMBER.MainNet) {
        return __awaiter(this, void 0, void 0, function* () {
            const bipString = NeonLedger_1.getNEOBIP44String();
            const ledger = this.useLedger();
            const ledgerAdapter = adapterForVersion(this.version);
            const publicKey = this.publicKey;
            const scriptHash = neon_core_next_1.wallet.getScriptHashFromPublicKey(publicKey);
            const address = neon_core_next_1.wallet.getAddressFromScriptHash(scriptHash);
            return yield ledgerAdapter.getSignature(ledger, msg, bipString, magic);
        });
    }
    useLedger() {
        if (!this.ledger) {
            throw new Error("Ledger is not initialized");
        }
        return this.ledger;
    }
}
exports.NeoLedgerAccount = NeoLedgerAccount;
NeoLedgerAccount._connectPolling = false;
